import * as React from "react";
import type { AvatarProps } from "~/design-system/Avatar";
import { Avatar } from "~/design-system/Avatar";
import { createComponentHook } from "~/types";
import { useAvatarFromUserId_UserQuery } from "./AvatarFromUserId.graphql";

type AvatarFromUserIdProps = {
  userId: string;
};

type AvatarFromUserIdCombinedProps = AvatarFromUserIdProps & AvatarProps;

const useAvatarFromUserId = createComponentHook(
  (props: AvatarFromUserIdProps) => {
    const [{ data }] = useAvatarFromUserId_UserQuery({
      variables: { id: props.userId },
    });

    return {
      state: {
        avatarUrl: data?.user?.user_avatar?.public_url,
        userFullName: data?.user?.full_name,
      },
    };
  }
);

const AvatarFromUserId = (props: AvatarFromUserIdCombinedProps) => {
  const { userId, ...avatarProps } = props;
  const { state } = useAvatarFromUserId({ userId });

  if (state.avatarUrl) {
    return (
      <Avatar
        {...avatarProps}
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        alt={state.userFullName!}
        src={state.avatarUrl}
      />
    );
  } else {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return <Avatar {...avatarProps} alt={state.userFullName!} />;
  }
};

export { AvatarFromUserId };
